import React from "react";
import { useTranslation } from "react-i18next";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";

import { AtiraIcon } from "../../../components/AtiraIcon";
import { Text } from "../../../components/Text";
import { Badge } from "./DuplicateCardPrimitives";

export const MarkedForDeletionBadge: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Badge $tone="danger">
      <AtiraIcon icon={faTrash} color="white" size="xs" />
      <Text fontSize="xs" fontWeight="bold" color="white">
        {t("common.markedForDeletion")}
      </Text>
    </Badge>
  );
};
